export default "__VITE_ASSET__O306tlxv__"